import * as React from 'react';
import { useParams } from 'react-router';
import Form from '../../components/form/Form';
import Panel from '../../components/containers/Panel';

export default function ViewCompetency() {
    const { id } = useParams();

    return (
        <Panel>
            <Form id={id} objtype="competency" readonly={true} reloadOnUpdate={true}/>
        </Panel>
    )
}